import type { Theme } from '@material-ui/core'

export default function responsiveFontSizes(theme: Theme) {
  return {
    ...theme,
    typography: {
      ...theme.typography,
      h1: {
        ...theme.typography.h1,
        // [theme.breakpoints.down('lg')]: { fontSize: '2.41rem' },
        // [theme.breakpoints.down('md')]: { fontSize: '2.41rem' },
        [theme.breakpoints.down('sm')]: { fontSize: '2.0rem' }
      },
      h2: {
        ...theme.typography.h2,
        // [theme.breakpoints.down('lg')]: { fontSize: '1.74rem' },
        // [theme.breakpoints.down('md')]: { fontSize: '1.74rem' },
        [theme.breakpoints.down('sm')]: { fontSize: '1.25rem' }
      },
      h3: {
        ...theme.typography.h3,
        // [theme.breakpoints.down('lg')]: { fontSize: '1.36rem' },
        // [theme.breakpoints.down('md')]: { fontSize: '1.36rem' },
        [theme.breakpoints.down('sm')]: { fontSize: '1rem' }
      },
      h4: {
        ...theme.typography.h4,
        // [theme.breakpoints.down('lg')]: { fontSize: '1.07rem' },
        // [theme.breakpoints.down('md')]: { fontSize: '1.07rem' },
        [theme.breakpoints.down('sm')]: { fontSize: '0.96rem' }
      },
      h5: {
        ...theme.typography.h5,
        // [theme.breakpoints.down('lg')]: { fontSize: '0.96rem' },
        // [theme.breakpoints.down('md')]: { fontSize: '0.96rem' },
        [theme.breakpoints.down('sm')]: { fontSize: '0.96rem' }
      },
      h6: {
        ...theme.typography.h6,
        // [theme.breakpoints.down('lg')]: { fontSize: '0.77rem' },
        // [theme.breakpoints.down('md')]: { fontSize: '0.77rem' },
        [theme.breakpoints.down('sm')]: { fontSize: '0.96rem' }
      },
      subtitle1: {
        ...theme.typography.subtitle1,
        // [theme.breakpoints.down('lg')]: { fontSize: '0.96rem' },
        // [theme.breakpoints.down('md')]: { fontSize: '0.96rem' },
        [theme.breakpoints.down('sm')]: { fontSize: '0.77rem' }
      },
      subtitle2: {
        ...theme.typography.subtitle2,
        // [theme.breakpoints.down('lg')]: { fontSize: '0.88rem' },
        // [theme.breakpoints.down('md')]: { fontSize: '0.77rem' },
        [theme.breakpoints.down('sm')]: { fontSize: '0.77rem' }
      },
      body1: {
        ...theme.typography.body1,
        // [theme.breakpoints.down('lg')]: { fontSize: '0.96rem' },
        // [theme.breakpoints.down('md')]: { fontSize: '0.96rem' },
        [theme.breakpoints.down('sm')]: { fontSize: '0.88rem' }
      },
      body2: {
        ...theme.typography.body2,
        // [theme.breakpoints.down('lg')]: { fontSize: '0.77rem' },
        // [theme.breakpoints.down('md')]: { fontSize: '0.77rem' },
        [theme.breakpoints.down('sm')]: { fontSize: '0.88rem' }
      },
      button: {
        ...theme.typography.button,
        // [theme.breakpoints.down('lg')]: { fontSize: '0.96rem' },
        // [theme.breakpoints.down('md')]: { fontSize: '0.96rem' },
        [theme.breakpoints.down('sm')]: { fontSize: '0.925rem' }
      },
      caption: {
        ...theme.typography.caption,
        // [theme.breakpoints.down('lg')]: { fontSize: '0.77rem' },
        // [theme.breakpoints.down('md')]: { fontSize: '0.77rem' },
        [theme.breakpoints.down('sm')]: { fontSize: '0.77rem' }
      },
      overline: {
        ...theme.typography.overline,
        // [theme.breakpoints.down('lg')]: { fontSize: '0.77rem' },
        // [theme.breakpoints.down('md')]: { fontSize: '0.77rem' },
        [theme.breakpoints.down('sm')]: { fontSize: '0.77rem' }
      }
    }
  }
}
